import { useCallback, useMemo, useState } from 'react';

import { Tab } from '@/components/Tabs';

type UseTabs<T = string> = {
  initialTab: T;
  tabs: Tab<T>[];
};

export const useTabs = <T>({ initialTab, tabs: initialTabs }: UseTabs<T>) => {
  const [activeTab, setActiveTab] = useState(initialTab);

  const onTabClick = useCallback((tab: Tab<T>) => {
    setActiveTab(tab.name as T);
  }, []);

  const tabs = useMemo<Tab<T>[]>(() => initialTabs, [initialTabs]);

  return { activeTab, onTabClick, tabs };
};
